/**
 * Derive a never-blank initials string from a display name. A multi-word name yields the
 * first letter of its first two words; a single token (e.g. an email local-part) yields
 * its first two letters. Always upper-cased and never empty for a non-empty input.
 *
 * Shared cross-cutting helper: both the app-shell user pill (`shell/UserPill`) and the
 * self-service profile page (`features/profile`) render the same initials avatar, so the
 * helper lives in `shared/lib` — a feature must not reach into the shell layer's page
 * component to borrow it, and the shell must not depend on a feature for it.
 */
export function initialsFrom(name: string): string {
  const words = name.trim().split(/\s+/).filter(Boolean);
  const [first, second] = words;
  if (first === undefined) {
    return '?';
  }
  if (second === undefined) {
    return first.slice(0, 2).toUpperCase();
  }
  return (first.charAt(0) + second.charAt(0)).toUpperCase();
}
